export type ValidationOptions = {
  formats?: string[];
  maxSize?: number; // bites
};

export type ValidationResult = {
  isValid: boolean;
  errors: string[];
};

export async function validateImage(file: File, options: ValidationOptions): Promise<ValidationResult> {
  const errors: string[] = [];
  // Format
  if (options.formats) {
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (!options.formats.includes(extension || '')) {
      errors.push(`Неверный формат файла. Допустимые форматы: ${options.formats.join(', ')}`);
    }
  }
  // Max Size
  if (options.maxSize && file.size > options.maxSize) {
    errors.push(`Размер файла превышает допустимый (${(options.maxSize / 1024 / 1024).toFixed(1)} МБ)`);
  }

  return {
    isValid: !errors.length,
    errors,
  };
}

